import OutletService from '@/services/oulet.service'
import { loopRequests } from '@/utils/awaitLoop'
import localStorageKey from '@/constants/localStorageKey'
import { setLocalStorage } from '@/utils/localStorage'

export default {
  getListOutletByUser ({ commit }, storeId) {
    return OutletService.getOutletByStore(storeId)
      .then(outlet => {
        if (outlet.data && !!outlet.data.length) {
          outlet.data = outlet.data.filter(outletItem => {
            return outletItem.status
          })
        }
        setLocalStorage(localStorageKey.LIST_OUTLET, outlet.data)
        commit('SET_LIST_OUTLET', outlet.data)
      })
      .catch(error => commit('toast/NEW', { type: 'error', message: error.message }, { root: true }))
  },
  async getAllOutletByUser ({ commit }, storeIds) {
    try {
      const data = await loopRequests(storeIds, OutletService.getOutletByStore)
      commit('SET_ALL_OUTLETS', data)
      return data
    } catch (error) {
      commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
      return error
    }
  }
}
